import { DataIndexItem } from "../types/interfaces";
import { getLocationDataFromDataIndexItem } from "./potreeUtils";
import * as THREE from "three";


export function getCenterFromPCloud(record: DataIndexItem) {
    const locationData = getLocationDataFromDataIndexItem(record);
    if (locationData) {
        const center = locationData.center;
        const x = center.x;
        const y = center.y;

        const radius = locationData.radius;
        return new THREE.Vector3(x, y, radius)
    }
}


export function addBoxForSpaceMouse(inPCloud: any, record: DataIndexItem) {
    let bbox = inPCloud.pcoGeometry.tightBoundingBox;
    let boxSize = 1000
    let boxGeometry = new THREE.BoxGeometry(boxSize, boxSize, 1000);

    // let boxGeometry = new THREE.BoxGeometry(boxSize, boxSize, boxSize);
    let camera = window.potreeViewer.scene.getActiveCamera();
    let cameraPos = camera.position.clone();
    let cameraLookAt = window.potreeViewer.scene.view.getPivot()
    let dir = cameraLookAt.clone().sub(cameraPos).normalize();
    // dir.multiplyScalar(-1)
    let distance = 10000
    let boxPos = cameraPos.clone().add(dir.clone().multiplyScalar(distance))

    let boxMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false, side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.5
     })
    let box = new THREE.Mesh(boxGeometry, boxMaterial);
    let center = new THREE.Vector3();
    center.x = (bbox.max.x + bbox.min.x) / 2;
    center.y = (bbox.max.y + bbox.min.y) / 2;
    center.z = (bbox.max.z)
    box.visible = false;
    window.globalZ = bbox.min.z

    box.position.copy(cameraPos.clone().setZ(window.globalZ))
    window.potreeViewer.scene.scene.add(box);
    return box
}

// box.position.copy(boxCenter ? boxCenter.clone().setZ(bbox.min.z) : center.clone().setZ(bbox.min.z))
